import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Snackbar, SnackbarContent, styled, Typography } from '@mui/material';
import { amber, blue, green } from '@mui/material/colors';

import { hideMessage, type MessageVariant } from 'app/store/fuse/messageSlice';
import { Icon } from 'app/main/components';

const StyledSnackbar = styled(Snackbar)<{ variant: MessageVariant }>(({ theme, variant }) => ({
	'& .FuseMessage-content': {
		...(variant === 'success' && {
			backgroundColor: green[600],
			color: '#FFFFFF'
		}),

		...(variant === 'error' && {
			backgroundColor: theme.palette.error.dark,
			color: theme.palette.getContrastText(theme.palette.error.dark)
		}),

		...(variant === 'info' && {
			backgroundColor: blue[600],
			color: '#FFFFFF'
		}),

		...(variant === 'warning' && {
			backgroundColor: amber[600],
			color: '#FFFFFF'
		})
	}
}));

const variantIcon = {
	success: 'check-circle',
	warning: 'warning',
	error: 'error',
	info: 'information'
};

function FuseMessage() {
	const dispatch = useDispatch();
	const state = useSelector(({ fuse }: any) => fuse.message.state);
	const options = useSelector(({ fuse }: any) => fuse.message.options);

	return (
		<StyledSnackbar
			{...options}
			open={state}
			onClose={() => dispatch(hideMessage())}
			ContentProps={{
				variant: 'body2',
				headlineMapping: {
					body1: 'div',
					body2: 'div'
				}
			}}
		>
			<SnackbarContent
				className="FuseMessage-content"
				classes={{ action: 'p-8' }}
				message={
					<div className="flex items-center">
						{variantIcon[options.variant] && <Icon icon={variantIcon[options.variant]} color="inherit" />}
						<Typography className="mx-8" component="span">
							{options.message}
						</Typography>
					</div>
				}
				action={
					options.action ? (
						options.action
					) : (
						<IconButton
							key="close"
							aria-label="Close"
							color="inherit"
							onClick={() => dispatch(hideMessage())}
						>
							<Icon icon="close" />
						</IconButton>
					)
				}
			/>
		</StyledSnackbar>
	);
}

export default React.memo(FuseMessage);
